import React from 'react';
import { Section } from './ui';
export const WhatYouGet = () => {
  return <Section className="bg-brand-cream" data-id="element-265">
      <h2 className="text-3xl md:text-4xl font-serif font-bold text-center mb-12" data-id="element-266">
        Lo que recibes hoy
      </h2>

      <div className="bg-white rounded-3xl p-6 md:p-12 shadow-soft border border-gray-100 max-w-3xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6 md:gap-8 text-center md:text-left" data-id="element-267">
        <div className="flex-1" data-id="element-268">
          <div className="flex flex-col md:flex-row items-center gap-3 md:gap-4 mb-3" data-id="element-269">
            <span className="text-5xl" data-id="element-270">📘</span>
            <h3 className="text-xl md:text-3xl font-semibold font-serif text-brand-dark leading-tight" data-id="element-271">
              E-book “Pasteles Sin Culpa”
            </h3>
          </div>
          <p className="text-base md:text-lg text-gray-600" data-id="element-272">
            48 recetas maestras basadas en el Método de Estructura Húmeda™
          </p>
        </div>

        <div className="bg-gray-50 px-6 py-4 rounded-xl border border-gray-200 text-center w-full md:w-auto" data-id="element-273">
          <p className="text-xs md:text-sm text-gray-500 font-bold uppercase mb-1" data-id="element-274">
            Valor real
          </p>
          <p className="text-xl md:text-2xl font-bold text-gray-400 line-through decoration-red-500 decoration-2" data-id="element-275">
            $27.000 ARS
          </p>
        </div>
      </div>
    </Section>;
};